module.exports = __webpack_public_path__ + "img/print_icon.215fc9ba.svg";